import React, { useState } from 'react';
import { Modal, Button, Row, Col, Card, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilePdf, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

/**
 * Reusable PDF preview and download modal
 * @param {Object} props - Component props
 * @param {boolean} props.show - Whether to show the modal
 * @param {Function} props.onHide - Function to call when modal is closed
 * @param {Function} props.onSelect - Function to call when a template is selected
 * @param {Object} props.guarantee - The guarantee data
 * @param {boolean} props.loading - Whether PDF is currently being generated
 * @param {boolean} props.success - Whether PDF was successfully generated
 */
const PdfPreview = ({ 
  show, 
  onHide, 
  onSelect, 
  guarantee,
  loading = false, 
  success = false 
}) => {
  const [error, setError] = useState(null);
  
  // Track which template is currently being generated
  const [activeTemplate, setActiveTemplate] = useState(null);
  
  // Handle PDF generation directly in client
  const handleGeneratePdf = async (template) => {
    if (!guarantee) {
      // If no guarantee data, use the server-side generation
      setActiveTemplate(template);
      onSelect(template);
      // no client side generation
    }
  };
  
  // Determine if loading or success states are active
  const isLoading = loading;
  const isSuccess = success;
  
  return (
    <Modal 
      show={show} 
      onHide={onHide} 
      centered
      size="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title>PDF-Vorlage auswählen</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}
        
        {isSuccess && (
          <Alert variant="success" className="mb-3 d-flex align-items-center">
            <FontAwesomeIcon icon={faCheckCircle} className="me-2" size="lg" />
            <div>PDF erfolgreich generiert! Wird heruntergeladen...</div>
          </Alert>
        )}
        
        <Row>
          <Col md={6} className="mb-3">
            <Card className="h-100">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faFilePdf} size="4x" className="mb-3 text-primary" />
                <h5>White Paper</h5>
                <p className="text-muted small">Standardvorlage mit weißem Hintergrund</p>
                <Button 
                  variant="primary" 
                  className='white-paper'
                  onClick={() => {
                    setActiveTemplate('default');
                    guarantee ? handleGeneratePdf('default') : onSelect('default');
                  }}
                  disabled={isLoading}
                >
                  {isLoading && activeTemplate === 'default' ? 'Wird generiert...' : 'Auswählen'}
                </Button>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="mb-3">
            <Card className="h-100">
              <Card.Body className="text-center">
                <FontAwesomeIcon icon={faFilePdf} size="4x" className="mb-3 text-success" />
                <h5>Firmenvorlage</h5>
                <p className="text-muted small">PDF mit vordesignter Unternehmensvorlage</p>
                <Button 
                  variant="success" 
                  onClick={() => {
                    setActiveTemplate('branded');
                    guarantee ? handleGeneratePdf('branded') : onSelect('branded');
                  }}
                  disabled={isLoading}
                >
                  {isLoading && activeTemplate === 'branded' ? 'Wird generiert...' : 'Auswählen'}
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};

export default PdfPreview;